import React, { useEffect } from "react";
import Image from "./Image";
import { motion } from "framer-motion";

//VARIANTS
const container = {
  show: {
    transition: {
      staggerChildren: 0.35,
    },
  },
};

const item = {
  hidden: {
    opacity: 0,
    y: 200,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.6,
    },
  },
  exit: {
    opacity: 0,
    y: -200,
    transition: {
      ease: "easeInOut",
      duration: 0.8,
    },
  },
};

const itemMain = {
  hidden: {
    opacity: 0,
    y: 200,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.6,
    },
  },
};

const Loader = ({ setLoading }) => {
  return (
    <div className="loader">
      <motion.div
        className="loader-inner"
        variants={container}
        initial="hidden"
        animate="show"
        exit="exit"
        onAnimationComplete={() => setLoading(false)}
      >
        <motion.div variants={item} className="transition-image">
          <h1 className="made_with" style={{ fontSize: "62px" }}>
            Made With
          </h1>
        </motion.div>
        <ImageBlock variants={item} id="sass" />
        <ImageBlock variants={item} id="framer" />
        <ImageBlock variants={item} id="nodejs" />
        <ImageBlock variants={item} id="react" />
        <motion.div variants={itemMain} className="transition-image">
          <motion.img
            src={process.env.PUBLIC_URL + `/images/coder-zoomed.jpg`}
            alt="random alt"
            layoutId="main-coder"
            style={{ width: "400px" }}
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export const ImageBlock = ({ id, variants }) => {
  return (
    <motion.div className={`image-block ${id}`} variants={variants}>
      <Image
        src={process.env.PUBLIC_URL + `/images/${id}.png`}
        fallback={process.env.PUBLIC_URL + `/images/${id}.webp`}
        alt={id}
      />
    </motion.div>
  );
};
export default Loader;
